module.exports = __webpack_public_path__ + "static/media/involvementDetailTitle.ee669251.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/involvementDetailTitle.png
// module id = 453
// module chunks = 0